import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Login.css';

const USER_SERVICE_URL = process.env.REACT_APP_USER_SERVICE_URL || 'http://localhost:8090';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [resetToken, setResetToken] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      const response = await fetch(`${USER_SERVICE_URL}/admin/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email: email.trim() })
      });

      if (!response.ok) {
        let errorMessage = 'Failed to process request';
        try {
          const errorData = await response.json();
          errorMessage = errorData.message || errorMessage;
        } catch (parseError) {
          errorMessage = `Server error (${response.status}): ${response.statusText}`;
        }
        throw new Error(errorMessage);
      }

      const data = await response.json();
      setSuccess(true);
      setResetToken(data.token); // In production, this would be sent via email
    } catch (error) {
      console.error('Forgot password error:', error);
      setError(error.message || 'Failed to process password reset request');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="login-container">
        <div className="login-box">
          <div className="login-header">
            <h1>Reset Token Generated</h1>
            <p>Use this token to reset your password</p>
          </div>

          <div className="alert alert-success">
            <p><strong>Password reset token generated successfully!</strong></p>
            <p style={{ fontSize: '13px', marginTop: '10px' }}>
              This token is valid for 24 hours.
            </p>
          </div>

          {resetToken && (
            <div className="alert alert-info" style={{ marginTop: '15px' }}>
              <p><strong>Your Reset Token:</strong></p>
              <div style={{ 
                background: '#f8f9fa', 
                padding: '12px', 
                borderRadius: '6px', 
                marginTop: '10px',
                wordBreak: 'break-all',
                fontFamily: 'monospace',
                fontSize: '13px',
                border: '1px solid #bee5eb'
              }}>
                {resetToken}
              </div>
              <div style={{ marginTop: '15px', textAlign: 'center' }}>
                <Link 
                  to={`/reset-password?token=${encodeURIComponent(resetToken)}`} 
                  className="btn btn-primary"
                  style={{ display: 'inline-block', padding: '10px 20px', textDecoration: 'none' }}
                >
                  Reset Password Now
                </Link>
              </div>
            </div>
          )}

          <div style={{ marginTop: '20px', textAlign: 'center' }}>
            <Link to="/login" className="link-primary">
              Back to Login
            </Link>
          </div>

          <div className="login-footer">
            <p>© 2025 GHA Conference Admin</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <h1>Forgot Password</h1>
          <p>Enter your email to reset your password</p>
        </div>

        {error && (
          <div className="alert alert-error">
            <span>{error}</span>
          </div>
        )}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              id="email"
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              autoFocus
            />
          </div>

          <button 
            type="submit" 
            className="btn btn-primary btn-block"
            disabled={loading}
          >
            {loading ? 'Processing...' : 'Send Reset Link'}
          </button>
        </form>

        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <Link to="/login" className="link-primary">
            Back to Login
          </Link>
        </div>

        <div className="login-footer">
          <p>© 2025 GHA Conference Admin</p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
